import { startCase } from 'lodash'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { useState } from 'react'

import { Button } from './ui/button'
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger
} from './ui/collapsible'
import { Icons } from './ui/icons'
import { Label } from './ui/label'

import { Switch } from '@/components/ui/switch'

type PricingTierAdvancedSettingsProps = {
  settings: {
    [key: string]: {
      enabled: boolean
    }
  }
  loading?: boolean
  defaultOpen?: boolean
}

const PricingTierAdvancedSettings = ({
  settings,
  loading,
  defaultOpen = true
}: PricingTierAdvancedSettingsProps) => {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <Collapsible
      className="px-4 py-2 space-y-2 border border-border rounded-md"
      onOpenChange={(e) => setOpen(e)}
      open={open}
    >
      <CollapsibleTrigger asChild>
        <div className="flex items-center justify-between cursor-pointer">
          <h4 className="text-sm font-semibold text-primary">
            Active Features
          </h4>
          <Button className="p-0 w-9" size="sm" type="button" variant="ghost">
            {loading ? (
              <Icons.spinner className="w-4 h-4 mr-0" />
            ) : open ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
            <span className="sr-only">Toggle</span>
          </Button>
        </div>
      </CollapsibleTrigger>
      <CollapsibleContent className="space-y-2">
        <div className="max-h-[90vh] overflow-y-auto">
          <div className="space-y-4">
            {Object.entries(settings).map(([setting, value]) => {
              return (
                <div
                  className="space-y-2 flex flex-row items-center justify-between p-2 border border-border rounded-lg"
                  key={setting}
                >
                  <Label htmlFor={setting}>{startCase(setting)}</Label>
                  <Switch
                    checked={value?.enabled ?? false}
                    disabled
                    id={setting}
                    style={{ marginTop: 0 }}
                  />
                </div>
              )
            })}
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  )
}

export default PricingTierAdvancedSettings
